// IMAGE GALLERY
function imageGallery(imgs) {
    var featuredImage = document.getElementById("featuredImage");
    featuredImage.src = imgs.dataset.img;
    featuredImage.alt = imgs.alt;
    featuredImage.parentElement.style.display = "block";
}

// IMAGE GALLERY ACTIVE CLASS
var header = document.getElementById("product-image-gallery");
var btns = header.getElementsByClassName("product-image");
for (var i = 0; i < btns.length; i++) {
	btns[i].addEventListener("click", function() {
	var current = document.getElementsByClassName("active");
	if (current.length > 0) { 
	current[0].className = current[0].className.replace(" active", "");
	}
	this.className += " active";
	});
}

const addToCartForm = document.getElementById("add-to-cart-form");
const cartClarificationModal = document.getElementById("cart-clarification-modal");
const confirmCartButton = document.getElementById("confirm-cart-button");
const redirectButton = document.getElementById("redirect-button");
const pickupStatus = document.getElementById("pdp-section");

if (addToCartForm && cartClarificationModal && confirmCartButton && pickupStatus) {
    itemsInCart = parseInt(cartClarificationModal.dataset.cartCount);
    productIsPickupOnly = pickupStatus.dataset.pickupOnlyProduct == 'true';
    // If 0 items in cart and product is not pickup only, make user confirm they want in-person pickup
    if (itemsInCart == 0 && !productIsPickupOnly) {
	addToCartForm.addEventListener('submit', function(event) {
	    event.preventDefault();
	    cartClarificationModal.classList.remove('d-none')
	})

	confirmCartButton.addEventListener('click', function(event) {
	    addToCartForm.submit()
	})

	// Hide modal if user chose to go to shipping store
	redirectButton.addEventListener('click', function(event) {
	    cartClarificationModal.classList.add('d-none')
	})
    }
}
